import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCommon } from "../../Hooks/Common/useCommon";
import { AgGridReact } from "@ag-grid-community/react";
import DatePicker from "react-multi-date-picker";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { SkeletonDataTable } from "../Loader/Loader";
import RequestPopup from "./RequestPopup";
import { useLogRequestList } from "../../Hooks/Features/HelpDesk/useLogRequestList";
import { expriryData, handleDurationSelect } from "../../utils/Helper";
import CommonFilterDropdown from "../CommonCompo/CommonFilterDropdown/CommonFilterDropdown";
const LogRequestList = () => {

    const { loader, tagRef, columnDefs, filterValues, setFilterValues, getRequestedData, rowData, showRequestPopup, setShowRequestPopup, approval, setApproval, dropDownOption, handleStatusChange, showApprovePopup, setShowApprovePopup, navigate, handleRequest, editData, setEditData, showInfo } = useLogRequestList();
    const { checkPermission } = useCommon();

    return (
        <div ref={() => checkPermission("help desk", tagRef)}>
            <div ref={tagRef} id='{"tabname": "helpdesk", "data": "logs_tab"}' >
                <div className="row sk-header-row">
                    <div className="col-md-5 col-12">
                        <CommonFilterDropdown
                            fields={[
                                { key: "projects", label: "Project", col: 3 },
                                { key: "all_users", label: "Users", col: 3 },
                                { key: "log_environments", label: "Env Type", col: 3 },
                                { key: "log_type", label: "Log Type", col: 3 },
                            ]}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                        />
                    </div>
                    <div className="col-md-2 col-12">
                        <DatePicker
                            value={filterValues?.hoveredRange}
                            onChange={(e) => { setFilterValues((prev) => ({ ...prev, hoveredRange: e, isChange: true })); }}
                            range
                            rangeHover
                            placeholder="Select Date"
                            onClose={() => { if (filterValues?.isChange) { getRequestedData(); setFilterValues((prev) => ({ ...prev, isChange: false })) } }}
                        />
                    </div>
                    <div className="d-flex  align-items-center col-md-3 col-12">
                        {dropDownOption?.statusOptions?.map((item) => (
                            <div
                                key={item.request_status_id}
                                className="d-flex justify-content-center align-items-center"
                            >
                                <input
                                    type="radio"
                                    id={item.request_status_id}
                                    name="status"
                                    value={item.request_status_id}
                                    onChange={(e) => handleStatusChange(e)}
                                    checked={
                                        filterValues.status?.request_status_id ===
                                        item.request_status_id
                                    }
                                    className="sk-radio"
                                />
                                <label htmlFor={item.request_status_id} className="sk-radio-label">
                                    {item.request_status_name}
                                </label>
                            </div>
                        ))}
                    </div>
                    <div className="col-md-2 col-12 text-right">
                        {
                            <button className="sk-btn sk-btn-primary" onClick={() => navigate(-1)}>
                                <FontAwesomeIcon icon="fa-solid fa-arrow-left" />
                            </button>
                        }
                        <button className="sk-btn sk-btn-primary" onClick={() => getRequestedData()}><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" title="Refresh" /> </button>
                        <button className="sk-btn sk-btn-primary" onClick={() => setShowRequestPopup(true)}><FontAwesomeIcon icon="fa-solid fa-plus" title="Add Request" /> </button>
                    </div>
                </div>
                <div ref={() => checkPermission("help desk", tagRef)}>
                    <div ref={tagRef} id='{"tabname": "helpdesk", "data": "helpdesk_action_col"}' >
                        <div className="d-flex justify-content-end gap-2 ">
                            <button className="sk-btn sk-btn-primary " onClick={() => {
                                const data = rowData?.filter(item => item.is_checked === true)?.map(item => item.log_request_id)
                                if (data?.length <= 0 || !data) {
                                    showInfo("Info", "Please select a request to approve");
                                    return
                                }
                                setShowApprovePopup(true);
                                setApproval((prevState) => ({ ...prevState, data, status: "is_approved", selectedRadio: "" }))
                            }}>Approve All</button>

                            <button className="sk-btn sk-btn-danger " onClick={() => handleRequest("is_rejected", rowData?.filter(item => item.is_checked === true)?.map(item => item.log_request_id))}>Reject All</button>
                        </div>
                    </div>
                </div>
                {loader ? <div><SkeletonDataTable numSkeletons={15} /></div> :
                    <div className="ag-theme-alpine" style={{ height: "calc(100vh - 110px)" }}>
                        <AgGridReact
                            rowData={rowData}
                            columnDefs={columnDefs}
                            rowHeight={30}
                            headerHeight={30}
                        />
                    </div>
                }
                <Dialog visible={showApprovePopup} header="Approve Request" onHide={() => {
                    setShowApprovePopup(false);
                }} className="modal-small" draggable={false}>
                    <div className="">
                        <div className="w-50 inspectra-calendar">
                            <span>
                                Expiry Date
                            </span>
                            <Calendar className="input-dd" value={approval?.expiryDate}
                                onChange={(e) => setApproval((prev) => ({ ...prev, expiryDate: e.target.value, selectedRadio: "" }))}
                                dateFormat='dd-mm-yy' placeholder="Select date"
                                minDate={new Date()}
                                maxDate={new Date(new Date().setMonth(new Date().getMonth() + 3))}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-center text-center my-2" >
                        <hr style={{ flex: 1, }} className="border-top border-secondary" />
                        <span style={{ padding: '0 10px', color: '#666' }}>OR</span>
                        <hr style={{ flex: 1, }} className="border-top border-secondary" />
                    </div>
                    <div>
                        <div className="">
                            Expiry Duration
                        </div>
                        {expriryData?.map((d) => (
                            <div className="form-check-inline" key={d.value}>
                                <input
                                    type="radio"
                                    id={d.value}
                                    name="duration"
                                    value={d.value}
                                    checked={d.value === approval?.selectedRadio}
                                    onChange={(e) => setApproval((prev) => ({ ...prev, expiryDate: handleDurationSelect(d.value), selectedRadio: d.value }))}
                                    className="sk-radio"
                                />
                                <label htmlFor={d.value} className="sk-radio-label">
                                    {d.label}
                                </label>
                            </div>
                        ))}
                    </div>
                    <div className="d-flex gap-2 justify-content-center my-4" >
                        <button className="sk-btn sk-btn-primary"
                            onClick={() => handleRequest(null)}
                        > Confirm </button>
                        <button
                            onClick={() => {
                                setShowApprovePopup(false)
                            }}
                            className="sk-btn sk-btn-primary">
                            Cancel
                        </button>
                    </div>
                </Dialog>
                {
                    showRequestPopup && <RequestPopup showRequestPopup={showRequestPopup} setShowRequestPopup={setShowRequestPopup} editData={editData} setEditData={setEditData} callApi={getRequestedData} type="logs_tab" />
                }
            </div>
        </div>
    )
}

export default LogRequestList